module.exports = __webpack_public_path__ + "img/20211011_3.a5942ab8.png";